import { render, staticRenderFns } from "./EditarJugador.vue?vue&type=template&id=412c4aac"
import script from "./EditarJugador.vue?vue&type=script&lang=js"
export * from "./EditarJugador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports